module.exports = __webpack_public_path__ + "static/media/4.22ab5936.jpg";